/**
 * Full-viewport "Switching identity…" scrim for the DESKTOP app.
 *
 * On web, VauSwitchButton paints its own scrim while an assume/release is in
 * flight — but that button lives inside the desktop-hidden opti-common-header,
 * so a native-menu identity switch showed a frozen window until the hard reload.
 * BaseLayout renders this instead, driven by useDesktopAccountBar's pending
 * state. Mirrors the web scrim's look.
 *
 * Box exposes `z` but NOT position/inset or arbitrary backgroundColor as
 * sprinkles, so those go through `style` (same reason as the web scrim).
 */
import { Box, Flex, Spinner, Text } from '@optiaxiom/react';

export function IdentitySwitchScrim({ message }: { message: string }) {
  return (
    <Box
      z="toast"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(15, 15, 20, 0.55)',
      }}
    >
      <Flex flexDirection="column" alignItems="center" justifyContent="center" h="full" gap="16">
        <Spinner size="xl" />
        <Text fontSize="lg" color="fg.default">
          {message}
        </Text>
      </Flex>
    </Box>
  );
}
